var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-layout-dashboard-icon lucide-layout-dashboard",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 9,
    x: 3,
    y: 3,
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 5,
    x: 14,
    y: 3,
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 9,
    x: 14,
    y: 12,
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 5,
    x: 3,
    y: 16,
    rx: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhite);
export default __webpack_public_path__ + "static/media/dashboard_white.acadf4254cb62c2624948fe5c1481f4b.svg";
export { ForwardRef as ReactComponent };